import { selectCustomTariffsState } from "redux/customTariffsPage/selectors/selectCustomTariffsState";
import { createSelector } from "reselect";

export const selectSimpleUsers = createSelector([selectCustomTariffsState], (state) => state.simpleUsers);
